module.exports = __webpack_public_path__ + "left.1-U-Wv0-.svg";